import { PrintPage, ASSETS } from "../components/nk/print/PrintKit";
import { ALTERATIONS, ALTERATION_STEPS } from "../data";

const CREDS = [
  "Over 12 years' experience",
  "Creative & detailed",
  "Highly skilled",
  "Fast turnaround",
  "Affordable",
];

const ICON = {
  ig: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z",
  fb: "M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647z",
  tt: "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z",
};

const Social = ({ d }) => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true"><path d={d} /></svg>
);

const SocialRow = ({ className = "" }) => (
  <div className={`flex items-center gap-[3mm] text-ink/90 ${className}`}>
    <Social d={ICON.ig} />
    <Social d={ICON.fb} />
    <Social d={ICON.tt} />
    <span className="text-[8px] uppercase tracking-[0.2em]">@nkbridalaustralia</span>
  </div>
);

export default function AlterationsPamphletPage() {
  return (
    <PrintPage
      pageW={148}
      pageH={210}
      title="Alterations flyer — A5 double-sided"
      subtitle="Two pages (front & back) · print double-sided"
      note="Print double-sided (flip on long edge) on A5, margins None + Background graphics. Exactly two A5 pages."
    >
      {/* ---------- FRONT ---------- */}
      <div className="artboard" data-testid="alt-pamphlet-front" style={{ width: "148mm", height: "210mm", overflow: "hidden", background: "#FDFBF7" }}>
        <div className="pk-grain h-full w-full flex flex-col" style={{ padding: "12mm" }}>
          {/* header */}
          <div className="flex items-center gap-4">
            <img src={ASSETS.logoDark} alt="NK Bridal" style={{ height: "16mm", width: "auto" }} className="object-contain" />
            <div className="border-l border-line pl-4">
              <p className="font-serif font-semibold text-ink leading-none" style={{ fontSize: "15pt" }}>NK Bridal</p>
              <p className="text-[9px] uppercase tracking-[0.35em] text-ink mt-1">Australia</p>
            </div>
          </div>

          <h1 className="font-serif font-semibold text-ink mt-[7mm]" style={{ fontSize: "30pt", lineHeight: 1 }}>
            Wedding <span className="italic">Alterations</span>
          </h1>
          <p className="text-champagne font-serif font-semibold italic mt-[2mm]" style={{ fontSize: "13pt" }}>
            A famous Brisbane seamstress, now in Perth
          </p>

          {/* portrait + credentials */}
          <div className="grid grid-cols-2 gap-[7mm] mt-[7mm]">
            <div className="relative overflow-hidden border border-line" style={{ aspectRatio: "3 / 4" }}>
              <img src={ASSETS.handStitch} alt="Nancy Khau" className="w-full h-full object-cover object-center" />
              <div className="absolute left-0 bottom-0 bg-ivory px-[4mm] py-[2.5mm] border-t border-r border-line">
                <p className="font-serif font-semibold text-ink leading-none" style={{ fontSize: "12pt" }}>Nancy</p>
                <p className="text-[7.5px] uppercase tracking-[0.28em] text-ink mt-[1mm]">Principal Seamstress</p>
              </div>
            </div>
            <ul className="space-y-[3.5mm] self-center">
              {CREDS.map((c) => (
                <li key={c} className="flex items-center gap-2">
                  <span className="block w-[9px] h-px bg-champagne shrink-0" />
                  <span className="font-semibold text-ink" style={{ fontSize: "11pt", lineHeight: 1.25 }}>{c}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* message */}
          <div className="mt-[7mm] space-y-[3mm]">
            <p className="text-ink/95 font-semibold" style={{ fontSize: "11pt", lineHeight: 1.5 }}>
              Every dress has a unique fabric and design, and should be customised to fit your body.
            </p>
            <p className="font-serif font-semibold italic text-ink" style={{ fontSize: "13pt", lineHeight: 1.35 }}>
              Book your free consultation appointment and be looked after by Nancy, our principal seamstress herself.
            </p>
          </div>

          {/* footer */}
          <div className="mt-auto border-t border-ink pt-[4mm] flex items-end justify-between">
            <p className="font-serif font-semibold tracking-tight text-ink leading-none" style={{ fontSize: "20pt" }}>0433&nbsp;601&nbsp;060</p>
            <div className="flex flex-col items-end">
              <p className="text-[9.5px] tracking-[0.12em] text-ink/95">nkbridalaustralia.com.au</p>
              <SocialRow className="justify-end mt-[2mm]" />
              <p className="text-[8.5px] uppercase tracking-[0.22em] text-ink/95 mt-[2mm]">Perth · Australia-wide</p>
            </div>
          </div>
        </div>
      </div>

      {/* ---------- BACK ---------- */}
      <div className="artboard" data-testid="alt-pamphlet-back" style={{ width: "148mm", height: "210mm", overflow: "hidden", background: "#FDFBF7" }}>
        <div className="pk-grain h-full w-full flex flex-col" style={{ padding: "10mm" }}>
          <p className="text-[9px] uppercase tracking-[0.35em] text-champagne">What we alter</p>
          <h2 className="font-serif font-semibold text-ink mt-[1.5mm]" style={{ fontSize: "18pt", lineHeight: 1 }}>Every detail, considered</h2>
          <div className="grid grid-cols-2 gap-x-[6mm] gap-y-[4.5mm] mt-[5mm]">
            {ALTERATIONS.map((a) => (
              <div key={a.t}>
                <div className="flex items-center gap-2">
                  <span className="block w-[7px] h-px bg-champagne shrink-0" />
                  <b className="font-semibold text-ink" style={{ fontSize: "10pt" }}>{a.t}</b>
                </div>
                <p className="text-ink font-semibold mt-[0.5mm]" style={{ fontSize: "7.5pt", lineHeight: 1.3, paddingLeft: "15px" }}>{a.d}</p>
              </div>
            ))}
          </div>
          <p className="text-ink font-semibold italic mt-[4mm]" style={{ fontSize: "8.5pt" }}>
            Steaming and a final press included. Any gown welcome — bought anywhere.
          </p>

          <p className="text-[9px] uppercase tracking-[0.35em] text-champagne mt-[8mm]">How it works</p>
          <div className="mt-[5mm] space-y-[5mm]">
            {ALTERATION_STEPS.map((s) => (
              <div key={s.no} className="flex items-baseline gap-[4mm] border-b border-line pb-[3.5mm]">
                <span className="font-serif font-semibold text-champagne" style={{ fontSize: "14pt" }}>{s.no}</span>
                <div>
                  <span className="font-serif font-semibold text-ink" style={{ fontSize: "12pt" }}>{s.t}</span>
                  <span className="text-ink font-semibold" style={{ fontSize: "8.5pt" }}> — {s.d}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-auto border-t border-ink pt-[4mm] flex items-center justify-between">
            <img src={ASSETS.logoDark} alt="NK Bridal" style={{ height: "10mm", width: "auto" }} className="object-contain" />
            <div className="text-right">
              <p className="font-serif font-semibold italic text-ink" style={{ fontSize: "12pt" }}>Book your fitting today</p>
              <p className="text-ink/90 mt-[1mm]" style={{ fontSize: "9pt" }}>0433 601 060 · nkbridalaustralia.com.au</p>
              <SocialRow className="justify-end mt-[1.5mm]" />
            </div>
          </div>
        </div>
      </div>
    </PrintPage>
  );
}
